import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconJourneyLogo(props: IconProps) {
  return (
    <BaseIcon viewBox="0 0 24 24" {...props}>
      <path
        fill="url(#a)"
        d="M5.723 0A9.655 9.655 0 0 0 12 2.307 9.655 9.655 0 0 0 18.277 0l2.29 2.29A12.876 12.876 0 0 1 12 5.538 12.875 12.875 0 0 1 3.432 2.29L5.722 0Z"
      />
      <path
        fill="url(#b)"
        d="M18.277 24A9.654 9.654 0 0 0 12 21.693 9.655 9.655 0 0 0 5.723 24l-2.29-2.29A12.875 12.875 0 0 1 12 18.462c3.287 0 6.287 1.227 8.568 3.248L18.278 24Z"
      />
      <path
        fill="url(#c)"
        d="M0 18.277A9.654 9.654 0 0 0 2.307 12 9.655 9.655 0 0 0 0 5.723l2.29-2.29A12.875 12.875 0 0 1 5.538 12c0 3.287-1.227 6.287-3.248 8.568L0 18.278Z"
      />
      <path
        fill="url(#d)"
        d="M24 5.723A9.655 9.655 0 0 0 21.693 12c0 2.394.868 4.586 2.307 6.277l-2.29 2.29A12.875 12.875 0 0 1 18.462 12c0-3.287 1.227-6.287 3.248-8.568L24 5.722Z"
      />
      <defs>
        <linearGradient id="a" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
        <linearGradient id="b" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
        <linearGradient id="c" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
        <linearGradient id="d" x1={0} x2={28.429} y1={0} y2={16.253} gradientUnits="userSpaceOnUse">
          <stop stopColor="#80AFFF" />
          <stop offset={1} stopColor="#8270DB" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
